import PropTypes from 'prop-types';
import { Motion, spring } from 'react-motion';
import { Button, ButtonOutlined, Icon } from 'platfi-ui-components';

function EmailClientTab({ onClickSendAnother, closeModal, onSuccess }) {
  return (
    <Motion defaultStyle={{ opacity: 0 }} style={{ opacity: spring(onSuccess ? 1 : 0) }}>
      {(opacity) => (
        <div
          className="o-modal-form u-align-center u-color-primary"
          style={{ opacity: opacity.opacity }}
        >
          <div className="o-modal__icon">
            <Icon className="a-svg-empty-funding-tab" icon="round_outlined_check" />
          </div>
          <h2 className="o-modal__title">
            Thanks, your report invitation was
            <br className="a-br-sml" />
            sent to the client!
          </h2>
          <div className="o-modal-form__actions">
            <ButtonOutlined
              className="o-modal-form__action"
              label="Send to another client"
              onClick={() => onClickSendAnother()}
              secondary
              large
            />
            <Button
              className="o-modal-form__action"
              label="Done"
              onClick={() => closeModal()}
              primary
              large
            />
          </div>
        </div>
      )}
    </Motion>
  );
}

EmailClientTab.propTypes = {
  onSuccess: PropTypes.bool,
  onClickSendAnother: PropTypes.func,
  closeModal: PropTypes.func,
};

export default EmailClientTab;
